import {
    configureStore,
    ThunkAction,
    Action,
    combineReducers,
    Reducer,
    Middleware,
} from "@reduxjs/toolkit";
import threadSlice from "../features/chat/chatSlice";
import sessionSlice from "../features/chat/sessionSlice";
import transientChatSlice from "../features/chat/transientChatSlice";
import {chatApi} from "../features/chat/chatApi";
import {bffApi} from "../features/chat/bffApi";
import {dibApi} from "../features/chat/dibApi";
import {dibadminApi} from "../dibAdminApiCodegen/emptyDibadminApi";
import {dibadminApiManual} from "../dibAdminApiManual/dibAdminApiManual";
import {responseStateMiddleware} from "./responseStateMiddleware";
import forbiddenReducer from "../features/auth/forbiddenSlice";
import {forbiddenMiddleware} from "./forbiddenMiddleware";
import {unauthorizedMiddleware} from "./unauthorizedMiddle";

// --- Determine build mode ---
const isDevelopment = process.env.NODE_ENV !== "production";

// --- Base Reducers and Middleware (always included) ---
export const baseReducers: Record<string, Reducer> = {
    chat: threadSlice,
    session: sessionSlice,
    transientChat: transientChatSlice,
    [chatApi.reducerPath]: chatApi.reducer,
    [bffApi.reducerPath]: bffApi.reducer,
    [dibApi.reducerPath]: dibApi.reducer,
    [dibadminApi.reducerPath]: dibadminApi.reducer,
    [dibadminApiManual.reducerPath]: dibadminApiManual.reducer,
    forbidden: forbiddenReducer,
};

export const baseMiddleware: Middleware[] = [
    chatApi.middleware,
    bffApi.middleware,
    dibApi.middleware,
    dibadminApi.middleware,
    dibadminApiManual.middleware,
    responseStateMiddleware,
    forbiddenMiddleware,
    unauthorizedMiddleware,
];

export const store = configureStore({
    reducer: baseReducers, // Use the dynamically built reducers object
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware()
            // Concatenate the dynamically built middleware array
            .concat(baseMiddleware),

    devTools: isDevelopment
        ? {
              trace: true,
              traceLimit: 25,
          }
        : false,
});

// --- Type definitions (adjust if necessary based on conditional features) ---
export type AppStore = typeof store;
export type AppDispatch = typeof store.dispatch;
// RootState might need adjustment if you rely on types from conditional features elsewhere
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;
